//
// Set or add and set the nested path to the specified value
//
export function setPath(object, path, value) {
    if (!path) {
        return undefined;
    }
    if (path.includes('/')) {
        let endingObject = JSON.parse(JSON.stringify(object));
        const newPath = path.substring(1); //TODO: splice(1)? test for startsWith instead of includes? - same for getPath
        const processArray = newPath.split('/');

        // This modifies the endingObject in place
        processArray.reduce((o,p,i) => o[p] = newPath.split('/').length === ++i ? value : o[p] || {}, endingObject)
        return(endingObject);    
    } else {
        return({ ...object, [path]: value })
    }
}

//
// Get value for the specified nested path 
//
export function getPath(object, path) {
    if (!path) {
        return undefined;
    }
    if (path.includes('/')) {
        const processArray = path.split('/').splice(1).reduce((prev, curr) => prev && prev[curr], object)
        return(processArray);
    }
    else {
        return(object[path]);
    }
}

/**
* Performs a deep merge of objects and returns new object. Does not modify
* objects (immutable) and merges arrays via concatenation.
*
* @param {...object} objects - Objects to merge
* @returns {object} New object with merged key/values
*/
export function mergeDeep(...objects) {
    const isObject = obj => obj && typeof obj === 'object';
    
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach(key => {
            const pVal = prev[key];
            const oVal = obj[key];
            
            if (Array.isArray(pVal) && Array.isArray(oVal)) {
              prev[key] = pVal.concat(...oVal);
            }
            else if (isObject(pVal) && isObject(oVal)) {
                prev[key] = mergeDeep(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        
        return prev;
    }, {});
}
  
// Test objects
// const obj1 = {
//     a: 1,
//     b: 1, 
//     c: { x: 1, y: 1 },
//     d: [ 1, 1 ]
// }
// const obj2 = {
//     b: 2, 
//     c: { y: 2, z: 2 },
//     d: [ 2, 2 ],
//     e: 2
// }
// const obj3 = mergeDeep(obj1, obj2);

// Out
// console.log(obj3);



export function removePath(object, path){
    const newPath = path.substring(1);
    const processArray = newPath.split('/');
    const depth = processArray.length;
    const result = processArray.reduce((o,p,i) => {
        //console.log(o, p, i);
        //console.log("");
        if (depth === i+1) {
            // if we're finally at the right level to remove the item
            // see if it's an object member or array member and remove correctly
            if (Array.isArray(o)) {
                return o.splice(p, 1);
            } 
            else {
                return delete o[p];
            }
        }
        else {
            // return the current element
            return o[p] || {} 
        }
        //depth === (i+1) ? delete o[p] : o[p] || {}
    }, object)
    return(result);
}

export function patchObject(startingObject, patchRequest){ 
    let status = 0;


    // Make a deep copy of the startingObject
    let endingObject = JSON.parse(JSON.stringify(startingObject));  
    patchRequest.map((x) => {
        switch(x.op.toLowerCase()) {
            case `add`:
            //console.log(`ADD ${x.path} = ${x.value}`);
                setPath(endingObject, x.path, x.value);
            // should check the path to make sure the base is okay then add the item
            //  or set an error
            break;

            case `remove`:
            //console.log(`REMOVE ${x.path}`);
                removePath(endingObject, x.path);
            break;

            case `replace`:
            //console.log(`REPLACE ${x.path} = ${x.value}`);
                setPath(endingObject, x.path, x.value);
            break;

            default: 
                status = -1;
            break;
        }
        return ({ endingObject, status })
    })
    return ({ endingObject, status })
};

export function generatePatch({startingObject, endingObject}){
    // let patchRequest = [];

    // Determine if we're working with two objects or two arrays at the top level
    
    // var startingType = toString.call(startingObject);
    // var endingType = toString.call(endingObject);

    // console.log(`patching...`, startingObject, `to...`, endingObject);

    // If the endingObject isn't an object, then there is nothing to patch
    //
    // if (!endingObject || Object.prototype.toString.call(endingObject) !== '[object Object]') {
    //     return patchRequest;
    // }

}

export var diff = function (obj1, obj2) {

    // Make sure an object to compare is provided

    //
    // Variables
    //

    var diffs = {};
    var key;


    //
    // Methods
    //

    /**
     * Check if two arrays are equal
     * @param  {Array}   arr1 The first array
     * @param  {Array}   arr2 The second array
     * @return {Boolean}      If true, both arrays are equal
     */
    var arraysMatch = function (arr1, arr2) {

        // Check if the arrays are the same length
        if (arr1.length !== arr2.length) return false;

        // Check if all items exist and are in the same order
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }

        // Otherwise, return true
        return true;

    };

    /**
     * Compare two items and push non-matches to object
     * @param  {*}      item1 The first item
     * @param  {*}      item2 The second item
     * @param  {String} key   The key in our object
     */
    var compare = function (item1, item2, key) {

        // Get the object type
        var type1 = Object.prototype.toString.call(item1);
        var type2 = Object.prototype.toString.call(item2);

        // If type2 is undefined it has been removed
        if (type2 === '[object Undefined]') {
            diffs[key] = null;
            return;
        }

        // If items are different types
        if (type1 !== type2) {
            diffs[key] = item2;
            return;
        }

        // If an object, compare recursively
        if (type1 === '[object Object]') {
            var objDiff = diff(item1, item2);
            if (Object.keys(objDiff).length > 0) {
                diffs[key] = objDiff;
            }
            return;
        }

        // If an array, compare
        if (type1 === '[object Array]') {
            if (!arraysMatch(item1, item2)) {
                diffs[key] = item2;
            }
            return;
        }

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (type1 === '[object Function]') {
            if (item1.toString() !== item2.toString()) {
                diffs[key] = item2;
            }
        } else {
            if (item1 !== item2 ) {
                diffs[key] = item2;
            }
        }

    };


    //
    // Compare our objects
    //

    // Loop through the first object
    for (key in obj1) {
        if (obj1.hasOwnProperty(key)) {
            compare(obj1[key], obj2[key], key);
        }
    }

    // Loop through the second object and find missing items
    for (key in obj2) {
        if (obj2.hasOwnProperty(key)) {
            if (!obj1[key] && obj1[key] !== obj2[key] ) {
                diffs[key] = obj2[key];
            }
        }
    }

    // Return the object of differences
    return diffs;

};